<template>

    <head>
        <title>Map of Community Hydro Monitoring</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
    </head>
    <section class="font-sans text-zinc-900 antialiased">
        <div class="flex h-[100dvh] w-full flex-col bg-zinc-100 dark:bg-zinc-100">
            <Navbar />
            <div id="map" class="h-[calc(100dvh-64px)]"></div>
        </div>
        <Modal :show="showModal" @close="closeModal" />
    </section>
</template>

<script>
import { Head, Link } from "@inertiajs/vue3";
import { ref, onMounted, onUnmounted } from 'vue';
import L from 'leaflet';
import "leaflet-draw";
import "leaflet.locatecontrol";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css";
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import Navbar from "./Components/Navbar.vue";
import Modal from "./Components/Modal.vue";

(function (window, document, undefined) {
    "use strict";

    L.WindBarb = {};

    L.WindBarb.version = '0.0.1';

    L.WindBarb.Icon = L.Icon.extend({
        options: {
            fillColor: '#2B85C7',
            pointRadius: 8,
            strokeWidth: 2,
            strokeLength: 15,
            barbSpaceing: 5,
            barbHeight: 15,
            forceDir: false
        },

        initialize: function (options) {
            options = L.Util.setOptions(this, options);
        },

        createIcon: function () {
            var div = document.createElement('div');
            var svg = this._createPoint();
            div.appendChild(svg);
            this._setIconStyles(div);
            return div;
        },

        _createPoint: function () {
            var svg, w, h, sw, r, fc;
            sw = this.options.strokeWidth, r = this.options.pointRadius, fc = this.options.fillColor;
            w = h = 2 * sw + 2 * r;
            var xmlns = "http://www.w3.org/2000/svg";
            svg = document.createElementNS(xmlns, 'svg');
            svg.setAttributeNS(null, 'width', w);
            svg.setAttributeNS(null, 'height', h);
            var c = document.createElementNS(xmlns, 'circle');
            c.setAttributeNS(null, 'stroke', '#010101');
            c.setAttributeNS(null, 'stroke-width', sw);
            c.setAttributeNS(null, 'fill', fc);
            c.setAttributeNS(null, 'cx', w / 2);
            c.setAttributeNS(null, 'cy', h / 2);
            c.setAttributeNS(null, 'r', r);
            svg.appendChild(c);
            return svg;
        },

        _createBarbs: function (speed) {
            var s, b, bn, bw, bh, bs, sw, sl, p, r, w, h, cx, cy, vb, xmlns, svg, g, fd;
            s = speed,
                b = { 5: 0, 10: 0, 50: 0 }
            bs = this.options.barbSpaceing,
                bh = this.options.barbHeight,
                r = this.options.pointRadius,
                sw = this.options.strokeWidth,
                sl = this.options.strokeLength,
                fd = this.options.forceDir,
                xmlns = "http://www.w3.org/2000/svg",
                svg = document.createElementNS(xmlns, "svg"),
                g = document.createElementNS(xmlns, "g");

            // Calculate number of each stroke and add path elements to svg group

            s = (s % 5) >= 2.5 ? parseInt(s / 5) * 5 + 5 : parseInt(s / 5) * 5;

            for (var i = s; i > 0;) {
                if (i - 50 >= 0) {
                    b[50] += 1;
                    i -= 50;
                } else if (i - 10 >= 0) {
                    b[10] += 1;
                    i -= 10;
                } else if (i - 5 >= 0) {
                    b[5] += 1;
                    i -= 5;
                } else {
                    break;
                }
            };

            // Calculate height and Width of S

            var bn = b[5] + b[10] + b[50];
            if (bn === 0) {
                var bw = 0;
            } else {
                var bw = (bn * bs);
                if ((b[5] === 1 && b[10] > 0) || (b[5] === 1 && b[50] > 0)) {
                    bw -= bs;
                }
                if (b[50] > 0) {
                    bw += 3 * b[50] * bs;
                }
            }

            // calculate additional padding needed
            p = Math.round(Math.sqrt(bh * bh + bw * bw)) + 2;

            // calculate width and height
            w = h = r * 2 + sw * 2 + 2 * (bw + sl) + 2 * p;
            vb = h - (r * 2 + sw * 2 + bh);

            // calculate center of circle
            cx = w / 2;
            cy = h / 2;

            svg.setAttributeNS(null, "width", w);
            svg.setAttributeNS(null, "height", h);
            svg.appendChild(g);

            if (fd === true) {
                var px, py, pt, M, H, L;
                // set the x pointer
                px = cx - r - sw * 0.5,
                    // set the y pointer
                    py = cy,
                    // set first M
                    M = px + ',' + py,
                    // set first h
                    H = px - sl,
                    // set the top x pointer
                    pt = H - (2 * bs);

                // draw first line
                var path = document.createElementNS(xmlns, "path");
                path.setAttributeNS(null, 'stroke', "#000000");
                path.setAttributeNS(null, 'stroke-width', sw);
                path.setAttributeNS(null, 'stroke-linecap', "butt");
                path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
                g.appendChild(path);
                // update pointer
                var px = H;
            }

            if (bn !== 0) {
                if (fd !== true) {
                    var px, py, pt, M, H, L;
                    // set the x pointer
                    px = cx - r - sw * 0.5,
                        // set the y pointer
                        py = cy,
                        // set first M
                        M = px + ',' + py,
                        // set first h
                        H = px - sl,
                        // set the top x pointer
                        pt = H - (2 * bs);

                    // draw first line
                    var path = document.createElementNS(xmlns, "path");
                    path.setAttributeNS(null, 'stroke', "#000000");
                    path.setAttributeNS(null, 'stroke-width', sw);
                    path.setAttributeNS(null, 'stroke-linecap', "butt");
                    path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
                    g.appendChild(path);
                    // update pointer
                    var px = H;
                }

                // Check if there is a 5kn barb
                if (b[5] === 1) {
                    var bl10, ang10, bl5;
                    // calculate length of 10kn barb
                    bl10 = Math.sqrt((2 * bs) * (2 * bs) + (bh * bh)),
                        // calculate angle of 10kn barb
                        ang10 = Math.atan(bh / (2 * bs)),
                        // calculate length of 5kn barb
                        bl5 = bl10 / 2;
                    // get starting point of barb
                    M = (px) + ',' + py,
                        // calculate x of 5kn barb using angle of 10kn barb
                        L = ((px) - (bl5 * Math.cos(ang10))) + ',' + (cy - bh * 0.5);

                    var path = document.createElementNS(xmlns, "path");
                    path.setAttributeNS(null, 'stroke', "#000000");
                    path.setAttributeNS(null, 'stroke-width', sw);
                    path.setAttributeNS(null, 'stroke-linecap', "butt");
                    path.setAttributeNS(null, 'd', 'M ' + M + ' L ' + L);
                    g.appendChild(path);

                    // if no other bars exist, draw little end line
                    if (b[10] == 0 && b[50] == 0) {
                        px -= (bs);
                        H = px;
                        var path = document.createElementNS(xmlns, "path");
                        path.setAttributeNS(null, 'stroke', "#000000");
                        path.setAttributeNS(null, 'stroke-width', sw);
                        path.setAttributeNS(null, 'stroke-linecap', "butt");
                        path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
                        g.appendChild(path);
                    }
                }

                for (var i = 0; i < b[10]; i++) {
                    M = px + ',' + py,
                        px -= bs,
                        H = px;
                    var path = document.createElementNS(xmlns, "path");
                    path.setAttributeNS(null, 'stroke', "#000000");
                    path.setAttributeNS(null, 'stroke-width', sw);
                    path.setAttributeNS(null, 'stroke-linecap', "butt");
                    path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
                    g.appendChild(path);
                    M = H + ',' + cy,
                        pt -= bs,
                        L = pt + ',' + (cy - bh);
                    var path = document.createElementNS(xmlns, "path");
                    path.setAttributeNS(null, 'stroke', "#000000");
                    path.setAttributeNS(null, 'stroke-width', sw);
                    path.setAttributeNS(null, 'stroke-linecap', "butt");
                    path.setAttributeNS(null, 'd', 'M ' + M + ' L ' + L);
                    g.appendChild(path);
                }

                if (b[50] > 0) {
                    M = px + ',' + py,
                        px -= bs,
                        H = px;
                    var path = document.createElementNS(xmlns, "path");
                    path.setAttributeNS(null, 'stroke', "#000000");
                    path.setAttributeNS(null, 'stroke-width', sw);
                    path.setAttributeNS(null, 'stroke-linecap', "butt");
                    path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
                    g.appendChild(path);

                    for (var i = 0; i < b[50]; i++) {
                        var p1, p2, p3;
                        pt -= bs,
                            p1 = px + ',' + cy,
                            p2 = pt + ',' + (cy - bh),
                            p3 = pt + ',' + cy;
                        var path = document.createElementNS(xmlns, "polygon");
                        path.setAttributeNS(null, 'stroke', "#000000");
                        path.setAttributeNS(null, 'stroke-width', sw);
                        path.setAttributeNS(null, 'fill', "#000000");
                        path.setAttributeNS(null, 'points', p1 + ' ' + p2 + ' ' + p3);
                        g.appendChild(path);
                        px -= 2 * bs,
                            pt -= bs;
                    }
                }
            }

            return { ax: cx, ay: cy, svg: svg };
        },

        _setIconStyles: function (img, name, a) {
            var sw, r, o;
            var options = this.options,
                size = L.point(options[name === 'shadow' ? 'shadowSize' : 'iconSize']),
                anchor;

            sw = this.options.strokeWidth,
                r = this.options.pointRadius;

            if (name === 'shadow') {
                anchor = a;
                img.style.width = anchor.x + 'px';
                img.style.height = anchor.y + 'px';
            } else {
                img.style.position = 'absolute';
                var w, h;
                w = h = 2 * sw + 2 * r;
                var x = w / 2;
                var y = h / 2;
                anchor = L.point([x, y]);
            }

            if (!anchor && size) {
                anchor = size.divideBy(2, true);
            }

            if (anchor) {
                img.style.marginLeft = (-anchor.x) + 'px';
                img.style.marginTop = (-anchor.y) + 'px';
            }

            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },

        createShadow: function () {
            var d, s, b;
            d = this.options.deg + 90,
                s = this.options.speed,
                b = this._createBarbs(s)

            var div = document.createElement('div');

            if (this.options.mirrorVel) {
                b.svg.style.transform = "rotate(" + d + "deg) scaleY(-1)";
                b.svg.style.MozTransform = "rotate(" + d + "deg) scaleY(-1)";
                b.svg.style.webkitTransform = "rotate(" + d + "deg) scaleY(-1)";
                b.svg.style.msTransform = "rotate(" + d + "deg) scaleY(-1)";
            } else {
                b.svg.style.transform = "rotate(" + d + "deg)";
                b.svg.style.MozTransform = "rotate(" + d + "deg)";
                b.svg.style.webkitTransform = "rotate(" + d + "deg)";
                b.svg.style.msTransform = "rotate(" + d + "deg)";
            }

            div.appendChild(b.svg);

            var anchor = { x: b['ax'], y: b['ay'] };
            this._setIconStyles(div, 'shadow', anchor);
            return div;
        }
    });

    L.WindBarb.icon = function (options) {
        return new L.WindBarb.Icon(options);
    };

}(this, document));

export default {
    name: "Home",
    components: {
        Head,
        Link,
        Navbar,
        Modal
    },
    props: {
        data_aws: {
            type: Array,
            required: true,
        },
        data_tma: {
            type: Array,
            required: true,
        },
        zoom: {
            type: String,
            required: true,
        },
        zoom500: {
            type: String,
            required: true,
        },
        zoom500u: {
            type: String,
            required: true,
        },
        zoomSnap: {
            type: String,
            required: true,
        },
        zoomDelta: {
            type: String,
            required: true,
        },
        hourActive: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const showModal = ref(false);

        function closeModal() {
            showModal.value = false;
        }

        function openModal() {
            showModal.value = true;
        }

        let map = null;

        function calculateBounds(data) {
            let minLat = Infinity;
            let maxLat = -Infinity;
            let minLon = Infinity;
            let maxLon = -Infinity;

            data.forEach(station => {
                const lat = parseFloat(station.lat);
                const lon = parseFloat(station.lon);

                minLat = Math.min(minLat, lat);
                maxLat = Math.max(maxLat, lat);
                minLon = Math.min(minLon, lon);
                maxLon = Math.max(maxLon, lon);
            });

            return {
                center: [(minLat + maxLat) / 2, (minLon + maxLon) / 2],
                zoomSnap: parseFloat(props.zoomSnap),
                zoomDelta: parseFloat(props.zoomDelta),
            };
        }

        // Fungsi untuk menghitung bounds dari ESRI JSON subdas
        function calculateSubdasBounds(esriData) {
            let minLat = Infinity;
            let maxLat = -Infinity;
            let minLon = Infinity;
            let maxLon = -Infinity;

            if (esriData.features && esriData.features.length > 0) {
                esriData.features.forEach(feature => {
                    if (feature.geometry && feature.geometry.rings) {
                        feature.geometry.rings.forEach(ring => {
                            ring.forEach(coord => {
                                // Konversi dari UTM ke LatLng
                                const [lng, lat] = utmToLatLng(coord[0], coord[1], 48, true);
                                minLat = Math.min(minLat, lat);
                                maxLat = Math.max(maxLat, lat);
                                minLon = Math.min(minLon, lng);
                                maxLon = Math.max(maxLon, lng);
                            });
                        });
                    }
                });
            }

            return {
                center: [(minLat + maxLat) / 2, (minLon + maxLon) / 2],
                bounds: [[minLat, minLon], [maxLat, maxLon]],
                zoomSnap: parseFloat(props.zoomSnap),
                zoomDelta: parseFloat(props.zoomDelta),
            };
        }

        function getLatestTime(data) {
            return new Date(Math.max(...data.map(station => new Date(station.created_at))));
        }

        function isStationActive(stationTime, latestTime) {
            const threeHoursInMs = props.hourActive * 60 * 60 * 1000;
            return (latestTime - new Date(stationTime)) <= threeHoursInMs;
        }

        // Cache hasil perhitungan
        const colorCache = new Map();

        function getColorByTemperature(temp, isActive) {
            const cacheKey = `${temp}-${isActive}`;

            if (colorCache.has(cacheKey)) {
                return colorCache.get(cacheKey);
            }

            if (!isActive) {
                colorCache.set(cacheKey, 'rgb(128, 128, 128)');
                return 'rgb(128, 128, 128)';
            }

            // Jika temperature null/undefined, kembalikan warna abu-abu
            if (temp === null || temp === undefined) {
                colorCache.set(cacheKey, 'rgb(128, 128, 128)');
                return 'rgb(128, 128, 128)';
            }

            const colors = [
                [0, [34, 211, 238]],
                [10, [34, 197, 94]],
                [20, [255, 215, 0]],
                [30, [255, 165, 0]],
                [40, [255, 0, 0]],
                [50, [153, 27, 27]]
            ];

            temp = Math.max(0, Math.min(50, temp));

            const i = colors.findIndex(([t]) => temp <= t);

            // Jika tidak ditemukan, kembalikan warna abu-abu (offline)
            if (i === -1) {
                colorCache.set(cacheKey, 'rgb(128, 128, 128)');
                return 'rgb(128, 128, 128)';
            }

            if (i === 0) {
                const color = `rgb(${colors[0][1]})`;
                colorCache.set(cacheKey, color);
                return color;
            }

            const [t1, c1] = colors[i - 1];
            const [t2, c2] = colors[i];
            const ratio = (temp - t1) / (t2 - t1);

            const rgb = c1.map((v, j) => Math.round(v + ratio * (c2[j] - v)));
            const color = `rgb(${rgb})`;
            colorCache.set(cacheKey, color);
            return color;
        }

        // Memoize getWindDirection (juga sering dipanggil!)
        const windDirectionCache = new Map();

        function getWindDirection(degrees) {
            if (windDirectionCache.has(degrees)) {
                return windDirectionCache.get(degrees);
            }

            const directions = [
                "Utara", "Timur Laut", "Timur", "Tenggara",
                "Selatan", "Barat Daya", "Barat", "Barat Laut"
            ];
            const index = Math.floor((degrees + 22.5) / 45) % 8;
            const result = directions[index];

            windDirectionCache.set(degrees, result);
            return result;
        }

        // OPTIONAL: Clear cache saat data refresh
        function clearAllCaches() {
            colorCache.clear();
            windDirectionCache.clear();
        }

        // Fungsi konversi UTM Zone 48S (EPSG:32748) ke WGS84 (lat/lon)
        function utmToLatLng(easting, northing, zone = 48, southern = true) {
            const k0 = 0.9996;
            const a = 6378137; // WGS84 semi-major axis
            const e = 0.081819191; // WGS84 eccentricity
            const e1sq = 0.006739497;
            const falseEasting = 500000;
            const falseNorthing = southern ? 10000000 : 0;

            const x = easting - falseEasting;
            const y = northing - falseNorthing;

            const M = y / k0;
            const mu = M / (a * (1 - Math.pow(e, 2) / 4 - 3 * Math.pow(e, 4) / 64 - 5 * Math.pow(e, 6) / 256));

            const e1 = (1 - Math.sqrt(1 - e * e)) / (1 + Math.sqrt(1 - e * e));

            const phi1 = mu + (3 * e1 / 2 - 27 * Math.pow(e1, 3) / 32) * Math.sin(2 * mu)
                + (21 * Math.pow(e1, 2) / 16 - 55 * Math.pow(e1, 4) / 32) * Math.sin(4 * mu)
                + (151 * Math.pow(e1, 3) / 96) * Math.sin(6 * mu)
                + (1097 * Math.pow(e1, 4) / 512) * Math.sin(8 * mu);

            const N1 = a / Math.sqrt(1 - Math.pow(e * Math.sin(phi1), 2));
            const T1 = Math.pow(Math.tan(phi1), 2);
            const C1 = e1sq * Math.pow(Math.cos(phi1), 2);
            const R1 = a * (1 - e * e) / Math.pow(1 - Math.pow(e * Math.sin(phi1), 2), 1.5);
            const D = x / (N1 * k0);

            const lat = phi1 - (N1 * Math.tan(phi1) / R1) * (
                Math.pow(D, 2) / 2
                - (5 + 3 * T1 + 10 * C1 - 4 * Math.pow(C1, 2) - 9 * e1sq) * Math.pow(D, 4) / 24
                + (61 + 90 * T1 + 298 * C1 + 45 * Math.pow(T1, 2) - 252 * e1sq - 3 * Math.pow(C1, 2)) * Math.pow(D, 6) / 720
            );

            const lon0 = ((zone - 1) * 6 - 180 + 3) * Math.PI / 180; // Central meridian
            const lon = lon0 + (D - (1 + 2 * T1 + C1) * Math.pow(D, 3) / 6
                + (5 - 2 * C1 + 28 * T1 - 3 * Math.pow(C1, 2) + 8 * e1sq + 24 * Math.pow(T1, 2)) * Math.pow(D, 5) / 120) / Math.cos(phi1);

            return [lon * 180 / Math.PI, lat * 180 / Math.PI]; // [lng, lat]
        }

        // Fungsi konversi ESRI JSON ke GeoJSON
        function esriToGeoJSON(esriJson) {
            const geojson = {
                type: "FeatureCollection",
                features: []
            };

            if (esriJson.features && esriJson.features.length > 0) {
                esriJson.features.forEach((feature, index) => {
                    const geojsonFeature = {
                        type: "Feature",
                        properties: feature.attributes || {},
                        geometry: null
                    };

                    if (esriJson.geometryType === "esriGeometryPolygon" && feature.geometry && feature.geometry.rings) {
                        const convertedRings = feature.geometry.rings.map(ring => {
                            return ring.map(coord => {
                                // Konversi dari UTM Zone 48S ke WGS84
                                return utmToLatLng(coord[0], coord[1], 48, true);
                            });
                        });

                        geojsonFeature.geometry = {
                            type: "Polygon",
                            coordinates: convertedRings
                        };
                    }

                    if (geojsonFeature.geometry) {
                        geojson.features.push(geojsonFeature);
                    }
                });
            }

            return geojson;
        }

        function isRefreshTime() {
            var now = new Date();
            const refreshTimes = Array.from({ length: 288 }, (_, i) => {
                const hours = Math.floor(i / 12);
                const minutes = (i % 12) * 5;
                return `${hours.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")}:15`;
            });
            var currentTime = now.toLocaleTimeString("en-US", {
                hour12: false,
            });
            return refreshTimes.includes(currentTime);
        }

        let refreshCheckTimeout;

        function scheduleRefreshCheck() {
            const now = new Date();
            const seconds = now.getSeconds();

            // Hanya check pada detik ke-15
            const msUntilNextCheck = ((15 - seconds + 60) % 60) * 1000 - now.getMilliseconds();

            refreshCheckTimeout = setTimeout(() => {
                if (isRefreshTime()) {
                    location.reload();
                } else {
                    scheduleRefreshCheck();
                }
            }, msUntilNextCheck);
        }

        function setInitialMapZoom(windowWidth) {
            var mapZoom;

            if (windowWidth < 500) {
                mapZoom = parseFloat(props.zoom500u);
            } else if (windowWidth = 500 && windowWidth < 1000) {
                mapZoom = parseFloat(props.zoom500);
            } else {
                mapZoom = parseFloat(props.zoom);
            }

            return mapZoom;
        }

        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        onMounted(async () => {
            // Load subdas_ciapus.json terlebih dahulu untuk mendapatkan bounds
            let subdasData = null;
            let mapSettings = null;

            try {
                const response = await fetch('/subdas_ciapus.json');
                subdasData = await response.json();
                // Hitung bounds dari subdas
                mapSettings = calculateSubdasBounds(subdasData);
            } catch (error) {
                console.error('Error loading subdas_ciapus.json:', error);
                // Fallback ke bounds dari data AWS jika gagal load subdas
                mapSettings = calculateBounds(props.data_aws);
            }

            map = L.map('map', {
                zoomControl: false,
                zoomSnap: mapSettings.zoomSnap,
                zoomDelta: mapSettings.zoomDelta
            });

            // Gunakan fitBounds jika ada bounds dari subdas, atau setView sebagai fallback
            if (mapSettings.bounds) {
                map.fitBounds(mapSettings.bounds, { padding: [20, 20] });
            } else {
                map.setView(mapSettings.center, setInitialMapZoom(windowWidth));
            }

            console.log(mapSettings.bounds);

            // Time control
            var time = L.control({ position: "topright" });

            time.onAdd = function (map) {
                var div = L.DomUtil.create("div", "time");

                var latestCreatedAt = props.data_aws.reduce((latest, current) => {
                    return current.created_at > latest ? current.created_at : latest;
                }, props.data_aws[0].created_at);

                function formatDate(dateString) {
                    var date = new Date(dateString);
                    return date.getFullYear() + '-' +
                        String(date.getMonth() + 1).padStart(2, '0') + '-' +
                        String(date.getDate()).padStart(2, '0') + ' ' +
                        String(date.getHours()).padStart(2, '0') + ':' +
                        String(date.getMinutes()).padStart(2, '0');
                }

                var formattedDateTime = formatDate(latestCreatedAt);

                div.className = "bg-zinc-100 dark:bg-zinc-100 ring-2 ring-black ring-opacity-25 font-sans font-medium text-[12px] text-zinc-900 dark:text-zinc-900 antialiased px-2 py-1.5 rounded";
                div.innerHTML = '<span>Waktu:</span> ' + '<span>' + formattedDateTime + ' WIB (Per 5 Menit)</span>';

                return div;
            };

            time.addTo(map);

            // Define tile layers
            const CartoDB_Voyager = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                subdomains: 'abcd'
            });

            const CartoDB_Positron = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                subdomains: 'abcd'
            });

            const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
            });

            // Add layers to the map
            CartoDB_Voyager.addTo(map);

            // Create a layer control
            const baseMaps = {
                "CartoDB Voyager": CartoDB_Voyager,
                "CartoDB Positron": CartoDB_Positron,
                "ESRI World Imagery": satelliteLayer,
            };

            L.control.layers(baseMaps, {}, { position: 'topright' }).addTo(map);

            // Zoom
            L.control.zoom({ position: 'topright' }).addTo(map);

            // Locate
            L.control.locate({
                position: "topright"
            }).addTo(map);

            // Scale Bar
            L.control.scale({ metric: true, imperial: false, position: 'bottomleft' }).addTo(map);

            // Tampilkan subdas_ciapus jika berhasil di-load
            if (subdasData) {
                // Konversi ESRI JSON ke GeoJSON
                const geojsonData = esriToGeoJSON(subdasData);

                // Tambahkan layer GeoJSON ke peta
                L.geoJSON(geojsonData, {
                    style: {
                        fillColor: '#dc2626',
                        fillOpacity: 0.03,
                        color: '#dc2626',
                        weight: 2,
                        opacity: 0.8
                    },
                    onEachFeature: function (feature, layer) {
                        if (feature.properties) {
                            const popupContent = `
                                <div class="font-sans text-zinc-900">
                                    <h3 class="font-bold text-sm mb-1">Sub DAS Ciapus</h3>
                                    <p class="text-[13px]">Luas: ${feature.properties.Ha ? feature.properties.Ha.toFixed(2) + ' Ha' : '-'}</p>
                                </div>
                            `;
                            layer.bindPopup(popupContent);
                        }
                    }
                }).addTo(map);
            }

            // Load dan tampilkan layer sungai
            fetch('/rivers_ciapus.json')
                .then(response => response.json())
                .then(riversData => {
                    L.geoJSON(riversData, {
                        style: function (feature) {
                            // Style berbeda untuk river dan stream
                            const isRiver = feature.properties.waterway === 'river';
                            return {
                                color: '#0ea5e9',
                                weight: isRiver ? 2 : 2,
                                opacity: isRiver ? 1 : 1
                            };
                        },
                        onEachFeature: function (feature, layer) {
                            if (feature.properties) {
                                const coords = feature.geometry.coordinates;
                                const startCoord = coords[0];
                                const endCoord = coords[coords.length - 1];
                                const popupContent = `
                                    <div class="font-sans text-zinc-900">
                                        <h3 class="font-bold text-sm mb-1">${feature.properties.name}</h3>
                                        <p class="text-[13px]">ID: ${feature.properties.id}</p>
                                        <p class="text-[13px] capitalize">Tipe: ${feature.properties.waterway}</p>
                                        <p class="text-[13px]">Jumlah Titik: ${coords.length}</p>
                                        <p class="text-[13px]">Koordinat Awal: ${startCoord[1].toFixed(6)}, ${startCoord[0].toFixed(6)}</p>
                                        <p class="text-[13px]">Koordinat Akhir: ${endCoord[1].toFixed(6)}, ${endCoord[0].toFixed(6)}</p>
                                    </div>
                                `;
                                layer.bindPopup(popupContent);
                            }
                        }
                    }).addTo(map);
                })
                .catch(error => {
                    console.error('Error loading rivers_ciapus.json:', error);
                });


            // Draw
            var editableLayers = new L.FeatureGroup();
            map.addLayer(editableLayers);

            var drawControl = new L.Control.Draw({
                edit: {
                    featureGroup: editableLayers
                },
                draw: {
                    polygon: true,
                    polyline: true,
                    rectangle: { showArea: false },
                    circle: true,
                    circlemarker: false,
                    marker: false
                }
            });
            map.addControl(drawControl);

            L.Edit.Circle = L.Edit.CircleMarker.extend({
                _createResizeMarker: function () {
                    var center = this._shape.getLatLng(),
                        resizemarkerPoint = this._getResizeMarkerPoint(center)

                    this._resizeMarkers = []
                    this._resizeMarkers.push(this._createMarker(resizemarkerPoint, this.options.resizeIcon))
                },

                _getResizeMarkerPoint: function (latlng) {
                    var delta = this._shape._radius * Math.cos(Math.PI / 4),
                        point = this._map.project(latlng)
                    return this._map.unproject([point.x + delta, point.y - delta])
                },

                _resize: function (latlng) {
                    var moveLatLng = this._moveMarker.getLatLng()
                    var radius
                    if (L.GeometryUtil.isVersion07x()) {
                        radius = moveLatLng.distanceTo(latlng)
                    }
                    else {
                        radius = this._map.distance(moveLatLng, latlng)
                    }
                    this._shape.setRadius(radius)
                    this._map.fire(L.Draw.Event.EDITRESIZE, { layer: this._shape })
                }
            })

            map.on(L.Draw.Event.CREATED, function (e) {
                var type = e.layerType, layer = e.layer;

                if (type === 'polygon' || type === 'rectangle') {
                    var area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
                    if (area.toFixed(2) < 1000000) {
                        layer.bindPopup("Area: " + area.toFixed(2) + " m²");
                    } else if (area.toFixed(2) > 1000000) {
                        layer.bindPopup("Area: " + (area / 1000000).toFixed(2) + " km²");
                    }
                } else if (type === 'polyline') {
                    var length = 0;
                    var latlngs = layer.getLatLngs();
                    for (var i = 0; i < latlngs.length - 1; i++) {
                        length += latlngs[i].distanceTo(latlngs[i + 1]);
                    }
                    if (length.toFixed(2) < 1000) {
                        layer.bindPopup("length: " + length.toFixed(2) + " m");
                    } else if (length.toFixed(2) > 1000) {
                        layer.bindPopup("length: " + (length / 1000).toFixed(2) + " km");
                    }
                } else if (type === 'circle') {
                    var center = layer.getLatLng();
                    var radius = layer.getRadius();
                    if (radius.toFixed(2) < 1000) {
                        layer.bindPopup("Latitude: " + center.lat.toFixed(6) +
                            "<br>Longitude: " + center.lng.toFixed(6) +
                            "<br>Radius: " + radius.toFixed(2) + " m");
                    } else if (radius.toFixed(2) > 1000) {
                        layer.bindPopup("Latitude: " + center.lat.toFixed(6) +
                            "<br>Longitude: " + center.lng.toFixed(6) +
                            "<br>Radius: " + (radius / 1000).toFixed(2) + " km");
                    }
                } else if (type === 'marker') {
                    var center = layer.getLatLng();
                    layer.bindPopup("Latitude: " + center.lat.toFixed(6) +
                        "<br>Longitude: " + center.lng.toFixed(6));
                }

                editableLayers.addLayer(layer);
            });

            map.on(L.Draw.Event.EDITED, function (e) {
                var layers = e.layers;
                layers.eachLayer(function (layer) {
                    if (layer instanceof L.Polygon) {
                        var area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
                        if (area.toFixed(2) < 1000000) {
                            layer.setPopupContent("Area: " + area.toFixed(2) + " m²");
                        } else if (area.toFixed(2) > 1000000) {
                            layer.setPopupContent("Area: " + (area / 1000000).toFixed(2) + " km²");
                        }
                    } else if (layer instanceof L.Polyline && !(layer instanceof L.Polygon)) {
                        var length = 0;
                        var latlngs = layer.getLatLngs();
                        for (var i = 0; i < latlngs.length - 1; i++) {
                            length += latlngs[i].distanceTo(latlngs[i + 1]);
                        }
                        if (length.toFixed(2) < 1000) {
                            layer.setPopupContent("length: " + length.toFixed(2) + " m");
                        } else if (length.toFixed(2) > 1000) {
                            layer.setPopupContent("length: " + (length / 1000).toFixed(2) + " km");
                        }
                    } else if (layer instanceof L.Circle) {
                        var center = layer.getLatLng();
                        var radius = layer.getRadius();
                        if (radius.toFixed(2) < 1000) {
                            layer.setPopupContent("Latitude: " + center.lat.toFixed(6) +
                                "<br>Longitude: " + center.lng.toFixed(6) +
                                "<br>Radius: " + radius.toFixed(2) + " m");
                        } else if (radius.toFixed(2) > 1000) {
                            layer.setPopupContent("Latitude: " + center.lat.toFixed(6) +
                                "<br>Longitude: " + center.lng.toFixed(6) +
                                "<br>Radius: " + (radius / 1000).toFixed(2) + " km");
                        }
                    } else if (layer instanceof L.Marker) {
                        var center = layer.getLatLng();
                        layer.setPopupContent("Latitude: " + center.lat.toFixed(6) +
                            "<br>Longitude: " + center.lng.toFixed(6));
                    }
                });
            });

            map.on(L.Draw.Event.DELETED, function (e) {
                var layers = e.layers;
                layers.eachLayer(function (layer) {
                    editableLayers.removeLayer(layer);
                });
            });

            // Dapatkan waktu terbaru dari semua stasiun
            const latestTime = getLatestTime(props.data_aws);

            function generatePopupHTML(station, isActive) {
                return `
                        <div class="font-sans w-[300px] text-zinc-900">
                            <div class="mb-0.5 flex flex-col items-center">
                                <h1 class="text-sm font-bold mb-0.5 text-center">${station.station_id}</h1>
                                <h3 class="text-[13px] mb-0.5">Waktu: ${station.created_at} WIB</h3>
                                <div class="flex gap-3 mb-0.5 text-[13px]">
                                    <h3>Lat: ${station.lat.toString().slice(0, 5)}</h3> 
                                    <h3>Lon: ${station.lon.toString().slice(0, 6)}</h3> 
                                    <h3>Alt: ${station.elevation}</h3>
                                </div>
                                <h3 class="text-[13px] font-semibold ${isActive ? 'text-green-600' : 'text-red-600'}">
                                    ${isActive ? 'Online' : 'Offline'}
                                </h3>
                            </div>
                            <div class="grid grid-cols-2 mb-2">
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Intensitas Hujan</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.rain_rate ? `${parseFloat(station.rain_rate)} mm` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Radiasi Matahari</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.solar ? `${parseFloat(station.solar)} W/m²` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Suhu Udara</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.temperature ? `${parseFloat(station.temperature)}°C` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Suhu Titik Embun</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.dew_point ? `${parseFloat(station.dew_point)}°C` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Kelembapan Udara</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.humidity ? `${parseFloat(station.humidity)}%` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Tekanan Udara</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.pressure ? `${parseFloat(station.pressure)} hPa` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Kecepatan Angin</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.wind_speed ? `${parseFloat(station.wind_speed)} m/s (${station.wind_speed_knot} kt)` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Arah Angin dari</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.wind_direction ? `${parseFloat(station.wind_direction)}° (${getWindDirection(parseFloat(station.wind_direction))})` : '-'}</h3>
                                </div>
                                <div class="text-center text-[13px] py-1.5">
                                    <a href="${station.link}" target="_blank" class="text-blue-600 hover:text-blue-800 underline underline-offset-4">Daftar Stasiun</a>
                                </div>
                                ${station.link_dashboard !== null ? `
                                <div class="text-center text-[13px] py-1.5">
                                    <a href="${station.link_dashboard}" target="_blank" class="text-blue-600 hover:text-blue-800 underline underline-offset-4">Lihat Dashboard</a>
                                </div>
                                ` : ''}
                                ${station.link_forecast_hourly !== null ? `
                                <div class="text-center text-[13px] py-1.5">
                                    <a href="${station.link_forecast_hourly}" target="_blank" class="text-blue-600 hover:text-blue-800 underline underline-offset-4">Prediksi Harian</a>
                                </div>
                                ` : ''}
                                ${station.link_forecast_daily !== null ? `
                                <div class="text-center text-[13px] py-1.5">
                                    <a href="${station.link_forecast_daily}" target="_blank" class="text-blue-600 hover:text-blue-800 underline underline-offset-4">Prediksi 10 Harian</a>
                                </div>
                                ` : ''}
                            </div>
                        </div>
                    `
            }

            function generateTmaPopupHTML(station, isActive) {
                return `
                        <div class="font-sans w-[280px] text-zinc-900">
                            <div class="mb-0.5 flex flex-col items-center">
                                <h1 class="text-sm font-bold mb-0.5">${station.station_id}</h1>
                                <h3 class="text-[13px] mb-0.5">Waktu: ${station.created_at} WIB</h3>
                                <div class="flex gap-3 mb-0.5 text-[13px]">
                                    <h3>Lat: ${station.lat.toString().slice(0, 5)}</h3> 
                                    <h3>Lon: ${station.lon.toString().slice(0, 6)}</h3> 
                                    <h3>Alt: ${station.elevation}</h3>
                                </div>
                                <h3 class="text-[13px] font-semibold ${isActive ? 'text-green-600' : 'text-red-600'}">
                                    ${isActive ? 'Online' : 'Offline'}
                                </h3>
                            </div>
                            <div class="grid grid-cols-2 mb-2">
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Tinggi Muka Air</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.water_depth ? `${parseFloat(station.water_depth)} cm` : '-'}</h3>
                                </div>
                                <div class="text-center py-2">
                                    <h3 class="text-[13px] font-semibold">Tinggi Sensor</h3>
                                    <h3 class="text-[13px] mt-0.5">${station.sensor_height ? `${parseFloat(station.sensor_height)} cm` : '-'}</h3>
                                </div>
                                <div class="text-center text-[13px] py-1.5">
                                    <a href="${station.link}" target="_blank" class="text-blue-600 hover:text-blue-800">Daftar Stasiun ➤</a>
                                </div>
                                 ${station.link_dashboard !== null ? `
                                <div class="text-center text-[13px] py-1.5">
                                    <a href="${station.link_dashboard}" target="_blank" class="text-blue-600 hover:text-blue-800">Lihat Dashboard ➤</a>
                                </div>
                                ` : ''}
                            </div>
                        </div>
                    `
            }

            // Marker AWS
            // Render markers secara bertahap untuk menghindari blocking
            let markersToRender = [...props.data_aws];

            // Buat fragment untuk batch rendering
            function renderMarkerBatch(startIndex, batchSize = 20) {
                const endIndex = Math.min(startIndex + batchSize, markersToRender.length);

                for (let i = startIndex; i < endIndex; i++) {
                    const station = markersToRender[i];
                    const isActive = isStationActive(station.created_at, latestTime);
                    const hasRainfall = parseFloat(station.rain_rate) >= 0.5;
                    const zIndexOffset = 5 * i;

                    let windMark = L.WindBarb.icon({
                        deg: parseFloat(station.wind_direction), // TAMBAHKAN - 180
                        speed: parseFloat(station.wind_speed_knot),
                        pointRadius: 13,
                        strokeWidth: 1.5,
                        fillColor: getColorByTemperature(parseFloat(station.temperature), isActive),
                        forceDir: true
                    });

                    const marker = L.marker([parseFloat(station.lat), parseFloat(station.lon)], {
                        icon: windMark,
                        zIndexOffset: zIndexOffset
                    });

                    // Lazy load popup - hanya generate saat diklik
                    let popupGenerated = false;
                    marker.on('click', function () {
                        if (!popupGenerated) {
                            this.bindPopup(generatePopupHTML(station, isActive)).openPopup();
                            popupGenerated = true;
                        }
                    });

                    marker.bindTooltip(
                        parseFloat(station.temperature) ? Math.round(parseFloat(station.temperature)).toString() : '-',
                        {
                            direction: 'center',
                            className: `tooltipTemp ${isActive ? (hasRainfall ? 'active-rainfall' : '') : 'inactive'}`,
                            permanent: true,
                            interactive: true,
                        }
                    ).addTo(map);
                }

                // Render batch berikutnya jika masih ada
                if (endIndex < markersToRender.length) {
                    requestAnimationFrame(() => renderMarkerBatch(endIndex, batchSize));
                }
            }

            // Mulai rendering bertahap
            renderMarkerBatch(0, 20);

            // Marker TMA
            // Get latest time for TMA stations (gunakan latestTime dari AWS untuk perbandingan)
            const latestTimeTma = latestTime;

            // Render TMA markers
            let tmaMarkersToRender = [...props.data_tma];

            function renderTmaMarkerBatch(startIndex, batchSize = 20) {
                const endIndex = Math.min(startIndex + batchSize, tmaMarkersToRender.length);

                for (let i = startIndex; i < endIndex; i++) {
                    const station = tmaMarkersToRender[i];
                    const isActive = isStationActive(station.created_at, latestTimeTma);
                    const zIndexOffset = isActive ? 1000 + (5 * i) : 5 * i; // Higher z-index if active, same as AWS if offline

                    // Create TMA marker icon using WindBarb with deg=0, speed=0, forceDir=false
                    let tmaWindMark = L.WindBarb.icon({
                        deg: 0,
                        speed: 0,
                        pointRadius: 13,
                        strokeWidth: 1.5,
                        fillColor: isActive ? '#38BDF8' : 'rgb(128, 128, 128)',
                        forceDir: false
                    });

                    const marker = L.marker([parseFloat(station.lat), parseFloat(station.lon)], {
                        icon: tmaWindMark,
                        zIndexOffset: zIndexOffset
                    });

                    // Lazy load popup - hanya generate saat diklik
                    let popupGenerated = false;
                    marker.on('click', function () {
                        if (!popupGenerated) {
                            this.bindPopup(generateTmaPopupHTML(station, isActive)).openPopup();
                            popupGenerated = true;
                        }
                    });

                    marker.bindTooltip(
                        station.water_depth ? parseFloat(station.water_depth).toFixed(0) : '-',
                        {
                            direction: 'center',
                            className: `tooltipTma ${isActive ? '' : 'inactive'}`,
                            permanent: true,
                            interactive: true,
                        }
                    ).addTo(map);
                }

                // Render batch berikutnya jika masih ada
                if (endIndex < tmaMarkersToRender.length) {
                    requestAnimationFrame(() => renderTmaMarkerBatch(endIndex, batchSize));
                }
            }

            // Mulai rendering TMA markers
            if (tmaMarkersToRender.length > 0) {
                renderTmaMarkerBatch(0, 20);
            }

            // Legend
            var legend = L.control({
                position: "bottomleft"
            });

            legend.onAdd = function (map) {
                var div = L.DomUtil.create("div", "legend");
                div.innerHTML = '<div class="legend-content">' +
                    '<img src="Legend_Hydro_c.png" alt="Legenda" class="w-auto h-[260px] lg:h-[300px] rounded-md shadow-2xl">' +
                    '</div>' +
                    '<button class="absolute top-1 right-1 text-gray-600 hover:text-gray-800 focus:outline-none">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">' +
                    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />' +
                    '</svg>' +
                    '</button>';

                L.DomEvent.on(div.querySelector('button'), 'click', function () {
                    map.removeControl(legend);
                    document.getElementById('legendControl').classList.remove('hidden');
                });

                return div;
            };

            legend.addTo(map);

            // Legend Control
            var legendControl = L.control({
                position: "bottomleft"
            });

            legendControl.onAdd = function (map) {
                var div = L.DomUtil.create("div", "legendControl");
                div.innerHTML = '<button id="legendControl" class="hidden bg-zinc-100 ring-2 ring-black ring-opacity-25 p-3 rounded">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 512 512">' +
                    '<path d="M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z" />' +
                    '</svg>' +
                    '</button>';

                L.DomEvent.on(div.querySelector('button'), 'click', function () {
                    legend.addTo(map);
                    document.getElementById('legendControl').classList.add('hidden');
                });

                return div;
            };

            legendControl.addTo(map);

            // Map Link Button
            var mapButtonLink = L.control({
                position: "topright"
            });
            mapButtonLink.onAdd = function (map) {
                var div = L.DomUtil.create("div", "mapButtonLink lg:hidden");
                div.innerHTML = '<button id="mapButtonLink" class="bg-zinc-100 ring-2 ring-black ring-opacity-25 px-1 pt-1 rounded">' +
                    '<a href="https://map.sinaubumi.org/" target="_blank" class="flex flex-col items-center">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" class="h-[20px] w-auto" viewBox="0 0 512 512">' +
                    '<path d="M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16 .5 0 1.1 0 1.6 0 53 0 96 43 96 96s-43 96-96 96L96 320zm1.6 68.2c1.1-2.5 3.6-4.2 6.4-4.2s5.3 1.6 6.4 4.2l30.2 68.2c2.2 5.1 3.4 10.5 3.4 16 0 21.9-18.1 39.6-40 39.6s-40-17.7-40-39.6c0-5.5 1.2-11 3.4-16l30.2-68.2zm152 0c1.1-2.5 3.6-4.2 6.4-4.2s5.3 1.6 6.4 4.2l30.2 68.2c2.2 5.1 3.4 10.5 3.4 16 0 21.9-18.1 39.6-40 39.6s-40-17.7-40-39.6c0-5.5 1.2-11 3.4-16l30.2-68.2zm121.8 68.2l30.2-68.2c1.1-2.5 3.6-4.2 6.4-4.2s5.3 1.6 6.4 4.2l30.2 68.2c2.2 5.1 3.4 10.5 3.4 16 0 21.9-18.1 39.6-40 39.6s-40-17.7-40-39.6c0-5.5 1.2-11 3.4-16z"/>' +
                    '</svg>' +
                    '<p class="font-sans text-[12px] font-semibold text-zinc-900">AWS</p>' +
                    '</a>' +
                    '</button>';
                return div;
            };
            mapButtonLink.addTo(map);

            // AWQM Link Button
            var awqmButtonLink = L.control({
                position: "topright"
            });
            awqmButtonLink.onAdd = function (map) {
                var div = L.DomUtil.create("div", "awqmButtonLink lg:hidden");
                div.innerHTML = '<button id="awqmButtonLink" class="bg-zinc-100 ring-2 ring-black ring-opacity-25 px-1 pt-1 pb-[2px] rounded">' +
                    '<a href="https://awqm.sinaubumi.org/" target="_blank" class="flex flex-col items-center">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" class="h-[20px] w-auto" viewBox="0 0 384 512">' +
                    '<path d="M192 512C86 512 0 426 0 320 0 228.8 130.2 45.9 166.6-3.5 172.5-11.5 181.8-16 191.8-16l.4 0c10 0 19.3 4.5 25.2 12.5 36.4 49.4 166.6 232.3 166.6 323.5 0 106-86 192-192 192zM112 312c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 75.1 60.9 136 136 136 13.3 0 24-10.7 24-24s-10.7-24-24-24c-48.6 0-88-39.4-88-88z"/>' +
                    '</svg>' +
                    '<p class="font-sans text-[12px] font-semibold text-zinc-900">AWQ</p>' +
                    '</a>' +
                    '</button>';
                return div;
            };
            awqmButtonLink.addTo(map);

            // FWI Link Button
            var fwiButtonLink = L.control({
                position: "topright"
            });
            fwiButtonLink.onAdd = function (map) {
                var div = L.DomUtil.create("div", "fwiButtonLink lg:hidden");
                div.innerHTML = '<button id="fwiButtonLink" class="bg-zinc-100 ring-2 ring-black ring-opacity-25 px-[7px] pt-1 rounded">' +
                    '<a href="https://fwi.sinaubumi.org/" target="_blank" class="flex flex-col items-center">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" class="h-[21px] w-auto" viewBox="0 0 448 512">' +
                    '<path d="M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z" />' +
                    '</svg>' +
                    '<p class="font-sans text-[12px] font-semibold text-zinc-900">FWI</p>' +
                    '</a>' +
                    '</button>';
                return div;
            };
            fwiButtonLink.addTo(map);

            // HPT Link Button
            var hptButtonLink = L.control({
                position: "topright"
            });
            hptButtonLink.onAdd = function (map) {
                var div = L.DomUtil.create("div", "hptButtonLink lg:hidden");
                div.innerHTML = '<button id="hptButtonLink" class="bg-zinc-100 ring-2 ring-black ring-opacity-25 px-1.5 pt-1 rounded">' +
                    '<a href="https://hpt.sinaubumi.org/" target="_blank" class="flex flex-col items-center">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" class="h-[22px] w-auto" viewBox="0 0 576 512">' +
                    '<path d="M178.5 495.2c-7.5 9.6-21 12.1-31.3 5.3S133.5 480 138.9 469l1.2-2.2 36.2-58 0-41 .3-4c.6-3.9 2.2-7.7 4.6-10.9l39.3-52.2-66.2 59.5c-17 15.3-39 23.7-61.9 23.8l-8.1 0c-46.6 0-84.4-37.8-84.4-84.4 0-43 32.4-79.2 75.1-83.9l130.5-14.5-44.8-38.3-2.4-2.4c-5.3-6-7.3-14.4-5.3-22.3l13.3-53.4-25.9-38.9-1.3-2.1c-5.8-10.8-2.7-24.6 7.4-31.7 10.1-7.1 23.7-5.1 31.4 4.3l1.5 2 32 48 1.4 2.2c2.8 5.3 3.5 11.6 2.1 17.6l-12.3 49.2 53.3 45.7 0-28.8c0-11.8 6.5-22.1 16-27.7l0-60.5 .3-3.3c1.5-7.3 8-12.7 15.7-12.7s14.2 5.5 15.7 12.7l.3 3.2 0 60.5c9.6 5.5 16 15.8 16 27.7l0 28.9 53.4-45.8-12.3-49.2c-1.5-5.9-.7-12.2 2.1-17.6l1.4-2.2 32-48 1.5-2c7.7-9.4 21.3-11.5 31.4-4.3 10.1 7.1 13.1 20.9 7.4 31.7l-1.3 2.1-25.9 38.9 13.3 53.4c2 8-.1 16.3-5.3 22.3l-2.4 2.4-44.7 38.3 130.5 14.5c42.8 4.8 75.1 40.9 75.1 83.9 0 46.6-37.8 84.4-84.4 84.4l-8.1 0c-22.8 0-44.9-8.5-61.9-23.8l-66.1-59.5 39.2 52.2c2.4 3.2 4 7 4.6 10.9l.3 4 0 41 36.2 58 1.2 2.1c5.4 11 2 24.7-8.3 31.5s-23.8 4.4-31.3-5.3l-1.4-2-40-64-1.6-3.1c-1.4-3.1-2.1-6.6-2.1-10.1l0-39.8-32.4-43.1 0 74.7c0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32l0-74.6-32.3 43 0 39.8c0 3.5-.7 6.9-2.1 10.1l-1.6 3.1-40 64-1.4 2z"/>' +
                    '</svg>' +
                    '<p class="font-sans text-[12px] font-semibold text-zinc-900">HPT</p>' +
                    '</a>' +
                    '</button>';
                return div;
            };
            hptButtonLink.addTo(map);

            document.getElementById('toggleAbout').addEventListener('click', openModal);
            document.getElementById('toggleAbouts').addEventListener('click', openModal);

            scheduleRefreshCheck();
            setInterval(clearAllCaches, 300000);
        });

        onUnmounted(() => {
            if (map) {
                map.remove();
            }

            // TAMBAHKAN cleanup untuk timeout
            if (refreshCheckTimeout) {
                clearTimeout(refreshCheckTimeout);
            }

            document.getElementById('toggleAbout').removeEventListener('click', openModal);
            document.getElementById('toggleAbouts').removeEventListener('click', openModal);
        });

        return {
            showModal,
            closeModal,
            openModal
        };
    },
};
</script>

<style>
@import 'leaflet/dist/leaflet.css';
@import 'leaflet-draw/dist/leaflet.draw.css';
@import 'leaflet.locatecontrol/dist/L.Control.Locate.min.css';

.leaflet-container {
    height: 100%;
    width: 100%;
}

.leaflet-control-scale {
    padding: 2px 5px;
}

.tooltipTemp {
    background: rgba(0, 0, 0, 0) !important;
    color: white;
    border: none !important;
    font-size: 12px;
    box-shadow: none !important;
    font-weight: 700 !important;
    -webkit-text-stroke: 2px #18181b;
    paint-order: stroke fill;
}

.tooltipTemp.active-rainfall {
    background: rgba(0, 0, 0, 0) !important;
    color: #7ad7ff !important;
    -webkit-text-stroke: 2px #075985;
    paint-order: stroke fill;
}

.tooltipTemp.inactive {
    color: white !important;
}

/* TMA Marker Styles */
.tma-marker {
    background: transparent !important;
    border: none !important;
}

.tma-marker-circle {
    width: 26px;
    height: 26px;
    background-color: #38BDF8;
    border: 2px solid #0c4a6e;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.tma-marker-circle.inactive {
    background-color: rgb(128, 128, 128);
    border-color: #404040;
}

.tooltipTma {
    background: rgba(0, 0, 0, 0) !important;
    color: white;
    border: none !important;
    font-size: 12px;
    box-shadow: none !important;
    font-weight: 700 !important;
    -webkit-text-stroke: 2px #0c4a6e;
    paint-order: stroke fill;
}

.tooltipTma.inactive {
    color: white !important;
    -webkit-text-stroke: 2px #404040;
}
</style>